import styled from 'styled-components';
import { Row, Column } from '@simplywallst/ui-core';
import { media } from '@simplywallst/ui-core';

export const AddTransactionWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  height: auto;
  margin-top: 15px;
`;

export const FieldWrapper = styled('div')`
  position: relative;
  margin-bottom: ${(props) => props.theme.x3spacePx}px;
`;

export const ActionRow = styled(Row)`
  margin-top: ${({ theme }) => theme.x1spacePx}px;
`;

export const AddTransactionField = styled(Column)`
  margin-bottom: ${({ theme }) => theme.x3space}rem;
  ${media.mdUp`
    margin-bottom: 0;
    &:first-child {
      padding-right: ${({ theme }) => theme.x1spacePx}px;
    }
    &:last-child {
      padding-left: ${({ theme }) => theme.x1spacePx}px;
    }
  `};
`;
